import { render } from "./AnalyprofitBase.vue?vue&type=template&id=2ed10192&scoped=true&ts=true"
import script from "./AnalyprofitBase.vue?vue&type=script&lang=ts"
export * from "./AnalyprofitBase.vue?vue&type=script&lang=ts"

import "./AnalyprofitBase.vue?vue&type=style&index=0&id=2ed10192&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed10192"]])

export default __exports__